# открытие видео, которое расположено во всплывающей новости
class window.Video
  constructor: ->
    @videoPreview = $('.js-video-preview')
    @videoIframe = @videoPreview.parent().find('iframe')

    @init()

  init: =>
    self = this

    @videoPreview.click (e) ->
      self.videoPreview.fadeOut(300)
      self.videoIframe[0].src += "?autoplay=1"
      e.preventDefault()


// WEBPACK FOOTER //
// ./assets/javascripts/app/video.coffee